import { MfaSendAlertProps } from "../../components/SmartErrorAlert";
import { textStartInstructions } from "../../components/MfaShared";
import { hasErrorMessage } from "../getApiErrorMessage";
import translate from "../translate";
import { ErrorContentGenerator, ErrorContentMap } from "./getAlertContent";
import { apiErrorContent as loginApiErrContent, isLoginResponse } from './loginErrors';

type LoginErrorState = 'invalidOtp' | 'expiredOtp';
type MfaSendErrorState = 'optedOut' | 'unknown' | 'govDelivery';
export type ErrState = LoginErrorState | MfaSendErrorState;

export const apiErrorContent: ErrorContentMap<ErrState> = {
    invalidOtp: {
        header: translate('code_is_invalid'),
        body: translate('invalid_code_one_more_try'),
        analyticsErr: "The code is invalid. You have 1 more try to re-enter your code. Your account will be locked for 1 hour, if the code doesn't match our records."
    },
    expiredOtp: {
        header: translate('code_expired_title'),
        body: translate('expired_code_one_more_try'),
        analyticsErr: "The code expired. You have 1 more try to request a new code. Your account will be locked for 1 hour, if the new code doesn't work."
    },
    unknown: loginApiErrContent.unknown,
    optedOut: {
        header: translate('to_start_getting_codes_again'),
        body: textStartInstructions,
        analyticsErr: 'To start getting security codes again: Text START to (888) 309-1154.Select "Text My Code" below.'
    },
    govDelivery: {
        header: translate("cant_send_code"),
        body: <>
            {translate('try_logging_into_account_later')}
            <p></p>
            {translate('access_right_now')} ({<a href="tel:18006334227">1-800-633-4227</a>}).
            {' '}{translate('tty_users_can_call')} {<a href="tel:1-877-486-2048">1-877-486-2048</a>}.
        </>,
        analyticsErr: "We can't send your security code right now. Try logging into your account later.If you need to access your account right now, call 1-800-MEDICARE (1-800-633-4227). TTY users can call 1-877-486-2048."
    }
};

export const mfaSendErrorFns = new ErrorContentGenerator<MfaSendAlertProps, 'field', ErrState>({
    apiErrorContent,
    invalidFieldMessages: { // dummy content - unused
        field: {
            linkText: 'security_code',
            messages: { empty: 'invalid_code' }
        }
    },
    invalidFieldHeader: 'enter_the_six_digit_code', // unused
    getRefMap: props => {
        return {
            field: props.fieldRef
        }
    },
    getErrState: (apiResponse, loginFailCount) => {
        if (!apiResponse || apiResponse.status === 200 || apiResponse.status === 204) {
            return null;
        }

        const responseData = apiResponse.data;
        if (isLoginResponse(responseData)) {
            if (apiResponse.status === 401) {
                const err = responseData.code;
                const isIncorrectCode = err === 'MFA_INVALID_OTP' || err === 'MFA_EXPIRED_OTP';
                if (isIncorrectCode) {
                    if (loginFailCount < 3) {
                        return null;
                    } else if (loginFailCount === 3) {
                        return err === 'MFA_INVALID_OTP' ? 'invalidOtp' : 'expiredOtp';
                    } else {
                        return null; // component will redirect to login page where locked err will be shown
                    }
                }
            }
        } else {
            const errors = responseData.errors;
            if (!errors) {
                return 'unknown';
            }
            if (hasErrorMessage(errors, 'MFA_GOVDELIVERY_UNAVAILABLE')) {
                return 'govDelivery';
            }
            if (hasErrorMessage(errors, 'MFA_USER_OPTED_OUT')) {
                return 'optedOut';
            }
        }

        return 'unknown';
    },
    getApiInvalidFields: () => [],
    isIntermediateStep: false
});